export interface Scheduling {
    /**
     * @title Início
     * @format date-time
     */
    start?: string

    /**
     * @title Fim
     * @format date-time
     */
    end?: string
}

export function isSchedulingActive(scheduling?: Scheduling) {
    if (!scheduling) return true
    const now = new Date()
    const { start, end } = scheduling
    if (!start && !end) return true
    if (start && !end) return now >= new Date(start)
    if (!start && end) return now <= new Date(end)
    return now >= new Date(start!) && now <= new Date(end!)
}
